module.exports = __webpack_public_path__ + "img/img2.35d2f71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/03/img2.png
// module id = 51
// module chunks = 0